module.exports = __webpack_public_path__ + "img/cart.b2a6f05.svg";